import { AsyncNamespace, defineEvent, EventTopic, otto } from "@otto-ec/global-resources/nexus";

export interface Page {
  sortiertnach?: string;
  l?: string;
  o?: string;
}

export interface FilterSectionLoadEvent {
  rule: string;
  page: Page;
  ssid?: string;
}

export interface FilterSectionInitialLoadedEvent {
  response: Response;
  rule: string;
}

export interface FacetValueTagsLoadedEvent {
  rule: string;
  tags: string[];
}

export interface FilterPersonalizationSaveEvent {
  values: string[];
}

export interface FilterPersonalizationSelectEvent {
  select: string[];
  trackingLabels: Partial<{[key: string]: string}>;
}

export interface FilterPersonalizationSelectedEvent {
  selected: string[];
  unselected: string[];
}

export type HeurekaEvents = {
  filterSection_load: EventTopic<FilterSectionLoadEvent>;
  filterSection_loaded: EventTopic<{}>;
  filterSection_initialLoaded: EventTopic<FilterSectionInitialLoadedEvent>;
  filterSection_loadAborted: EventTopic<{}>;
  facetValueTags_loaded: EventTopic<FacetValueTagsLoadedEvent>;
  filterVisibilities_load: EventTopic<FilterSectionLoadEvent>;

  filterPersonalization_save: EventTopic<FilterPersonalizationSaveEvent>;
  filterPersonalization_saved: EventTopic<FilterPersonalizationSaveEvent>;
  filterPersonalization_select: EventTopic<FilterPersonalizationSelectEvent>;
  filterPersonalization_selected: EventTopic<FilterPersonalizationSelectedEvent>;
  filterPersonalizationBanner_loaded: EventTopic<{}>;
  refinementBar_loaded: EventTopic<{}>;

  sliders_initialized: EventTopic<{}>;
}

declare global {
  interface NexusInterfaces {
    heureka: AsyncNamespace<HeurekaEvents>;
  }
}

otto.heureka.assignNamespace({
  filterSection_load: defineEvent(),
  filterSection_loaded: defineEvent(),
  filterSection_initialLoaded: defineEvent(),
  filterSection_loadAborted: defineEvent(),
  facetValueTags_loaded: defineEvent(),
  filterVisibilities_load: defineEvent(),

  filterPersonalization_save: defineEvent(),
  filterPersonalization_saved: defineEvent(),
  filterPersonalization_select: defineEvent(),
  filterPersonalization_selected: defineEvent(),
  filterPersonalizationBanner_loaded: defineEvent(),

  refinementBar_loaded: defineEvent(),

  sliders_initialized: defineEvent(),
});

export const heureka : HeurekaEvents = otto.heureka;
